import Salary from 'components/UI/Salary'

export const getAdminUserBillingTasksHeaders = () => {
  const headers = [
    { label: 'Nr', propName: 'lp', className: 'width-sm' },
    {
      label: 'Data',
      propName: 'standardized.date',
      type: 'date',
      rowClassName: 'text-center',
      className: 'text-center width-sm',
    },
    {
      label: 'Projekt',
      propName: 'project.name',
      rowClassName: 'text-center',
      className: 'text-center',
    },
    {
      label: 'Wynagrodzenie brutto',
      propName: 'computed1',
      type: 'computed',
      rowClassName: 'text-right',
      className: 'text-right',
      fn: (task) => <Salary task={task} />,
    },
  ]

  return headers
}
